import { createContext } from "react";

export const DatesContext = createContext({});
